import {
  PublishParams,
  CustomerFields,
  CustomerListParams,
  CustomerCategoryParams,
  CustomerSourceParams,
} from "../../view/Modules/Customers/CustomerDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const CustomerServices = {
  getCustomerCategories: (params: CustomerCategoryParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.CUSTOMER_CATEGORIES, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.CUSTOMER_CATEGORIES, { params });
  },
  getCustomerSources: (params: CustomerSourceParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.CUSTOMER_SOURCES, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.CUSTOMER_SOURCES, { params });
  },
  getCustomers: (params: CustomerListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.CUSTOMERS, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.CUSTOMERS, { params });
  },
  importCustomerFile: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.IMPORT_CUSTOMER_FILE, params),
  importBulkCustomers: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.IMPORT_BULK_CUSTOMERS, params),
  exportCustomers: (params: CustomerListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_CUSTOMERS, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "customers-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createCustomer: (data: CustomerFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_CUSTOMER, data),
  updateCustomer: (id: number, data: CustomerFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_CUSTOMER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishCustomer: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_CUSTOMER.replace(":id", id.toString()),
      data
    ),

  publishBulkCustomer: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_CUSTOMER, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteCustomer: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_CUSTOMER.replace(":id", id.toString())
    ),

  deleteBulkCustomer: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_CUSTOMER, idl);
  },

  updatePassword: (data: object) =>
    AxiosInstance.post(ContentApiRoutes.CHANGE_PASSWORD, data),

  CustomerLogout: () => AxiosInstance.post(ContentApiRoutes.LOGOUT),

  viewCustomer: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_CUSTOMER.replace(":id", id.toString())
    );
  },

  uploadImage: (id: any, file: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPLOAD_CUSTOMER_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT",
      file
    ),

  deleteCustomerImage: (id: number) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_CUSTOMER_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT"
    ),
  createAddress: (data: any) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_CUSTOMER_ADDRESS, data),

  updateAddress: (id: number, data: any) =>
    AxiosInstance.put(
      ContentApiRoutes.UPDATE_CUSTOMER_ADDRESS.replace(":id", id.toString()),
      data
    ),

  deleteAddress: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_CUSTOMER_ADDRESS.replace(":id", id.toString())
    ),
};
